import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LegalDocumentsService, ScrollSpyService, SentryService, SEOService } from '@box-core/services';
import { environment } from '@box-env/environment';
import { APIError, SeoOptions } from '@box-types';
import { deleteJsonLd } from '@box/utils';
import { finalize } from 'rxjs';

@Component({
  selector: 'account-terms-subpage',
  templateUrl: './account-terms-subpage.page.html',
  styleUrls: ['./account-terms-subpage.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountTermsSubPage implements OnInit, AfterViewInit, OnDestroy {
  public loading: boolean;
  public termsStylesUrl = environment.application.legalDocuments.STYLES_URL;
  public termsHtml: string;

  constructor(
    private sentryService: SentryService,
    private changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private scrollSpyService: ScrollSpyService,
    private legalDocumentsService: LegalDocumentsService,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setMetaTags();
  }

  ngAfterViewInit(): void {
    this.fetchTerms();
  }

  ngOnDestroy(): void {
    deleteJsonLd();
  }

  private fetchTerms(): void {
    this.loading = true;
    this.changeDetectorRef.detectChanges();
    const templateType = this.activatedRoute.snapshot.data.templateType;
    this.legalDocumentsService
      .fetchTermsAndConditions(templateType)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        })
      )
      .subscribe({
        next: (terms) => {
          this.termsHtml = terms;
          this.handleRouteFragment();
        },
        error: (error: APIError) =>
          this.sentryService.captureException(error, {
            domain: 'Account Terms',
            domainDetails: 'Fetch Terms And Conditions Document',
            severity: 'warning'
          })
      });
  }

  private handleRouteFragment(): void {
    const elementId = this.activatedRoute.snapshot.fragment;
    if (!elementId) return;
    this.scrollSpyService.scrollToElementWithId(elementId);
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
